import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';

import BreadcrumbsContext from './BreadcrumbsContext';

const BreadCrumbsProvider = ({ children }) => {
  const [crumbs, setCrumbs] = useState([]);
  const [deferredCrumbIds, setDeferredCrumbIds] = useState([]);

  const register = useCallback(
    (label, uri) => setCrumbs((prev) => [...prev, { label, uri }]),
    [setCrumbs],
  );

  const unregister = useCallback(
    (label) =>
      setCrumbs((prev) => prev.filter((crumb) => crumb.label !== label)),
    [setCrumbs],
  );

  const deferCrumb = useCallback(
    (id) => setDeferredCrumbIds((prev) => [...prev, id]),
    [setDeferredCrumbIds],
  );

  const resolveCrumb = useCallback(
    (id) =>
      setDeferredCrumbIds((prev) => prev.filter((crumbId) => crumbId !== id)),
    [setDeferredCrumbIds],
  );

  return (
    <BreadcrumbsContext.Provider
      value={useMemo(() => {
        return {
          crumbs,
          deferredCrumbIds,
          register,
          unregister,
          resolveCrumb,
          deferCrumb,
        };
      }, [
        crumbs,
        deferredCrumbIds,
        register,
        unregister,
        resolveCrumb,
        deferCrumb,
      ])}
    >
      {children}
    </BreadcrumbsContext.Provider>
  );
};

BreadCrumbsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BreadCrumbsProvider;
